import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { max } from "date-fns";

const SliderWrapper = styled.div<{ color: string }>`
  width: 100%;
  padding: 0 20px;
  display: flex;

  input {
    min-width: 95%;
    appearance: none;
    background: transparent;
    cursor: pointer;
  }
  input::-webkit-slider-runnable-track {
    background-color: ${(props) => props.color};
    height: 4px;
    border-radius: 2px;
    width: 100%;
    user-select: none;
  }
  input::-webkit-slider-thumb {
    appearance: none;
    background-color: ${(props) => props.color};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    transform: translateY(-8px);
  }
  .plus-button {
    font-size: 23px;
    font-weight: 400;
    margin: 0 10px;
    cursor: pointer;
    animation: bubbleEffect 0.3s forwards;
  }

  @keyframes bubbleEffect {
    0% {
      transform: scale(0) translateY(-2px);
      filter: blur(10px);
    }
    70% {
      transform: scale(1.3) translateY(-2px);
      filter: blur(0);
    }

    100% {
      transform: scale(1) translateY(-2px);
      filter: blur(0);
    }
  }

  @media (max-width: 800px) {
    input::-webkit-slider-thumb {
      width: 23px;
      height: 23px;
      transform: translateY(-9px);
    }
  }
`;

export default function CustomSlider(props: Props) {
  const [showPlus, setShowPlus] = useState(false);
  const [maxValue, setMaxValue] = useState(8);

  useEffect(() => {
    if (props.value === props.max || props.value > 8) {
      setShowPlus(true);
    } else {
      setShowPlus(false);
      setMaxValue(props.max);
    }
  }, [props.value]);

  function addToMax() {
    setMaxValue(maxValue + 1);
    props.onChange(maxValue + 1);
    setShowPlus(true);
  }

  return (
    <SliderWrapper color={props.color}>
      <input
        type="range"
        min="0"
        max={maxValue}
        value={props.value}
        step={props.step ? props.step : 1}
        onChange={(e) => props.onChange(parseFloat(e.target.value))}
        className="slider"
        id="myRange"
      ></input>
      {showPlus && !props.fixedMax && (
        <span
          className="plus-button"
          style={{ color: props.color }}
          onClick={addToMax}
        >
          +
        </span>
      )}
    </SliderWrapper>
  );
}

interface Props {
  value: number;
  onChange: (value: number) => void;
  step: number;
  max: number;
  color: string;
  fixedMax?: boolean;
}
